import { render, staticRenderFns } from "./studentPri.vue?vue&type=template&id=a19b7aa0&scoped=true&"
import script from "./studentPri.vue?vue&type=script&lang=js&"
export * from "./studentPri.vue?vue&type=script&lang=js&"
import style0 from "./studentPri.vue?vue&type=style&index=0&id=a19b7aa0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a19b7aa0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
